import { AppLang } from "./sv";

const en: AppLang = {
	ADD: "Add",
	MATCH_ANY: "Any",
	MATCH_ALL: "All",
	SAVE_FILTER: "Save filter",
	UPDATE_FILTER: "Update filter",
	SHOW_RESULTS: "Show results",
	MANAGE_FILTERS: "Manage filters",
	NO_SAVED_FILTERS: "No saved filters yet",
	MODIFIED: "modified",
	MOVE_UP: "Move up",
	MOVE_DOWN: "Move down",
	ORG_CONSULTANT_FILTERS: "Consultant filters",
	ORG_CONSULTANT_FILTERS_DESC:
		"Shared filters everyone can apply on the consultant list. Only administrators can edit these.",
	ADD_FILTER: "Add filter",
	EDIT: "Edit",
	HIDE: "Hide",
	UPDATE: "Update",
	DONE: "Done",
	LEARN_MORE: "Learn more",
	NEW_FILTER: "New filter",
	EDIT_FILTER: "Edit filter",
	MY_FILTERS: "My filters",
	ORG_FILTERS: "Organisation filters",
	ORG_FILTERS_MANAGE_HINT:
		"Shared filters managed by administrators under Settings → List filters. They can't be edited here.",
	ORG_CONSULTANT_FILTERS_EMPTY_TITLE: "No consultant filters yet",
	ORG_CONSULTANT_FILTERS_EMPTY_DESC:
		"Create shared filters the whole organisation can use to quickly narrow the consultant list — e.g. by status, competence or manager.",
	LIST_FILTERS: "List filters",
	ORG_CUSTOMER_FILTERS: "Customer filters",
	ORG_CUSTOMER_FILTERS_DESC:
		"Shared filters everyone can apply on the customer list. Only administrators can edit these.",
	ORG_CUSTOMER_FILTERS_EMPTY_TITLE: "No customer filters yet",
	ORG_CUSTOMER_FILTERS_EMPTY_DESC:
		"Create shared filters the whole organisation can use to quickly narrow the customer list — e.g. by status, org unit or contract.",
	FILTER_NAME: "Filter name",
	UPDATE_OR_CREATE_FILTER:
		'You are editing the filter "{{name}}". Update it, or save as a new filter?',
	SAVE_AS_NEW: "Save as new",
	GENDER: "Gender",
	MALE: "Male",
	FEMALE: "Female",
	NOT_SET: "Not set",
	MANAGER: "Manager",
	SHOW_INACTIVE_MANAGERS: "Show inactive managers",
	HIDE_INACTIVE_MANAGERS: "Hide inactive managers",
	COMPETENCES: "Competences",
	SAVE: "Save",
	SAVE_SUCCESS_GENERIC: "Changes was saved",
	FIRST_NAME: "First name",
	LAST_NAME: "Last name",
	NAME: "Name",
	EMAIL: "Email",
	PERSONAL_NUMBER: "Personal number",
	PHONE: "Phone",
	ADDRESS: "Address",
	EMERGENCY_CONTACT: "Emergency contact",
	ADDRESS_PLACEHOLDER: "Street",
	ADDRESS_PLACEHOLDER_2: "c/o",
	CONSULTANT_CREATED: "Consultant was created",
	DATE_PLACEHOLDER: "YYYY-MM-DD",
	DESELECT: "Deselect",
	DOWNLOAD_EXPORT_FILE: "Download export",
	REPORT: "Report",
	TITLE: "Title",
	PUBLIC_PRESENTATION: "Public presentation",
	PUBLIC_PRESENTATION_AI_GENERATE: "Generate presentation",
	PUBLIC_PRESENTATION_AI_GENERATE_TOOLTIP_NO_COMPETENCES:
		"Need to add competences to generate presentation",
	PUBLIC_PRESENTATION_AI_GENERATE_TOOLTIP_NO_CV: "Need to upload CV to generate presentation",
	PRIVATE_NOTES: "Private notes",
	EVENTS_NOTE: "Events (not visible to consultant or customer)",
	INTERNAL_NOTES: "Internal Notes",
	PRIVATE_DESCRIPTION: "Private description",
	SAVE_CHANGES: "Save changes",
	EMPLOYEE_NO: "Employee no",
	COPY: "Copy",
	LAST_ACTIVE_ON_APP: "Last active on app",
	STATUS: "Status",
	JOBS: "Jobs",
	PROFILE: "Profile",
	COMPETENCE: "Competence",
	SKILL: "Skill",
	ADD_COMPETENCE: "Add Competence",
	INDUSTRY: "Branch",
	SERVICE: "Service",
	SALARY: "Salary",
	EMPLOYMENT_AND_SALARY: "Employment & salary",
	EMPLOYMENT: "Employment details",
	EMAIL_NOT_VALID: "Email not valid",
	PHONE_NO_NOT_VALID: "Phone no not valid",
	SOCIAL_SECURITY_NO_NOT_VALID: "Personal No not valid, ex 19901010-1122",
	ZIP_CODE_NOT_VALID: "Zip code not valid",
	CREATED: "Created",
	CREATED_BY: "Created by",
	UPDATED: "Updated",
	ADD_ROW: "Add row",
	SEARCH: "Search",
	NO_SEARCH_RESULTS: "No search results",
	LOGOUT: "Logout",
	DEACTIVATE: "Deactivate",
	ACTIVATE: "Activate",
	LOGGING_OUT: "Logging out...",
	PASSWORD: "Lösenord", //TODO
	FORGOT_PASSWORD: "Forgot password",
	RESET_PASSWORD: "Reset password",
	SET_PASSWORD: "Set password",
	SET_PASSWORD_SUCCESS: "Password has been updated",
	SEND: "Send",
	PASSWORD_REQUIRED: "Password is required",
	PASSWORD_MISMATCH: "Passwords should match",
	INVALID_TOKEN: "Reset link is not valid.",
	PASSWORD_VALIDATION_MESSAGE:
		"Require 8 characters with at least one capital letter, one simple letter and one number",
	ROLE: "Role",
	IS_ACTIVE: "Active",
	ACTIVE: "Active",
	ACTIVE_PLURAL: "Active",
	INACTIVE: "Inactive",
	INACTIVE_PLURAL: "Inactive",
	DELETED: "Deleted",
	POSTAL_CODE_PLACEHOLDER: "Postal Code",
	CITY_PLACEHOLDER: "City",
	FIELD_IS_REQUIRED: "Field is required",
	FIELD_MUST_BE_A_NUMBER: "Field must be a number",
	NUMBER_REQUIRED: "Field must be a number",
	SELECT_AT_LEAST_ONE_WEEKDAY: "Select at least one weekday",
	INVALID_TIME_FORMAT: "Invalid time format (HH:MM)",
	MUST_BE_POSITIVE_OR_ZERO: "Value must be 0 or greater",
	AT_LEAST_ONE_RULE_REQUIRED: "At least one rule is required",
	UNION_TYPE_INVALID: "Please select type of collective agreement",
	EMPLOYMENT_TYPE_INVALID: "Please select employment type",
	PENSION_TYPE_INVALID: "Please select type of pension",
	PHONE_PLACEHOLDER: "Phone Number",
	H: "h",
	ECONOMY: "Economy",
	ADMINISTRATION: "ADMINISTRATION",
	STAFFING: "Staffing",
	CLOSE: "Close",
	COLUMNS: "Columns",
	COLUMNS_DRAG_HINT: "Drag to reorder",
	COLUMNS_RESET: "Reset to default",
	COLUMNS_MOVE: "Move column",
	COLUMNS_PINNED_HINT: "Locked as first column",
	COLUMNS_DND_PICKED_UP: "Picked up {{name}}. Position {{position}} of {{total}}.",
	COLUMNS_DND_OVER: "{{name}} was moved to position {{position}} of {{total}}.",
	COLUMNS_DND_DROPPED: "{{name}} was dropped at position {{position}} of {{total}}.",
	COLUMNS_DND_CANCELLED: "Moving {{name}} was cancelled.",
	COLUMNS_DND_INSTRUCTIONS:
		"Press space bar to pick the column up. Use the arrow keys to move it. Press space bar again to drop it in its new position, or escape to cancel.",
	FROM_TO: "From - To",
	OK: "Close",
	ADD_ROWS: "Add rows",
	NONE: "None",
	URL_PLACEHOLDER: "https://",
	FLAG: "Flag",
	BREAK_AND_DEDUCTION: "Break/deduction",
	SEARCH_JOB: "Search job",
	SEARCH_CUSTOMER: "Search customer",
	SEARCH_CONSULTANT: "Search consultant",
	WARNING: "Warning",
	LOADING: "Loading",

	UNSAVED_CHANGES: "You have unsaved changes, do you want to continue?",
	SELECT_PLACEHOLDER: "Select",
	SELECT_DATE: "Select date",

	// Customer
	CUSTOMERS: "Customers",
	CUSTOMER_NO_SHORT: "Customer no",
	VAT_NO: "VAT",
	CREATE_CUSTOMER: "Create customer",
	MANAGE_CORPORATE_GROUPS: "List/manage corporate groups",
	LIST_CUSTOMER_USERS: "List customer users",
	CUSTOMER_USERS_LIST_TITLE: "Customer users",
	CUSTOMER_USERS_FILTER_ACTIVE: "Active",
	CUSTOMER_USERS_FILTER_INACTIVE: "Inactive",
	CUSTOMER_USERS_FILTER_ALL: "All",
	CUSTOMER_USERS_CUSTOMERS: "Customers",
	NEW_CUSTOMER: "New customer",
	ACTIVATE_CUSTOMER_TITLE: "Activate customer",
	DEACTIVATE_CUSTOMER_TITLE: "Deactivate customer",
	ACTIVATE_CUSTOMER_TEXT: "Are you sure you want to activate this customer",
	DEACTIVATE_CUSTOMER_TEXT: "Are you sure you want to deactivate this customer",
	UNBLOCK_CUSTOMER_TITLE: "Unblock customer",
	UNBLOCK_CUSTOMER_TEXT: "Are you sure you want to unblock this customer",
	SELECT_CUSTOMER: "Select customer",
	NO_CUSTOMERS: "There are no any customers for the search criteria",
	ORG_OR_PERSONAL_NUMBER: "Org/personal number",
	VISITING_ADDRESS: "Visiting address",
	BASIC_INFO: "Basic information",
	STREET_ADDRESS: "Street address",
	CUSTOMER_TYPE: "Customer type",
	IS_PRIVATE_PERSON: "Private person",
	INVOICE_NAME: "Name on invoice",
	SELECT_BOOKING_TYPE: "Select booking type",
	INVOICE_ADDRESS: "Invoice address",
	INVOICE_ADDRESS_LINE_1_PLACEHOLDER: "Street address or PO box",
	INVOICE_ADDRESS_LINE_2: "Invoice address 2",
	REFERENCE: "Reference",
	REFERENCE_PLACEHOLDER: "Reference",
	GLN: "GLN-kod",
	GLN_PLACEHOLDER: "GLN-kod",
	EMAIL_INVOICE: "Email",
	EMAIL_INVOICE_PLACEHOLDER: "Email",
	INVOICE_RECIPIENT: "Invoice recipient",
	E_INVOICE: "Invoice delivery",

	//Customer user
	REMOVE_USER_TITLE: "Remove user",
	DELETE_USER_CONFIRMATION_TEXT: "Are you sure you want to remove the user?",
	DELETE_USER_CONFIRMATION_BUTTON_TEXT: "Yes, delete the user",
	CANCEL: "No, not now",
	UNDO: "Undo",
	YES: "Yes",
	NO: "No",
	CONTACT_PERSON: "Contact person",
	SELECT_CONTACT: "Select contact",
	OTHER_CONTACT_PERSON: "Other contact person",
	DESCRIPTION: "Description",
	CREATE_USER: "Create user",
	UPDATE_USER: "Update user",
	INVOICE_DETAILS: "Invoice details",
	USERS: "Users",
	USER: "User",
	NEW_USER: "New user",
	CONTRACT_AND_PRICES: "Contract and prices",

	WEEK: "Week",
	DATE: "Date",
	WEEKDAY: "Weekday",
	START: "Start",
	END: "End",
	LENGTH: "Length",
	SHIFTS: "Shifts",
	SHIFTS_BOOKED: "Boooked shifts",
	ADD_SHIFTS: "Add Shift",

	RESOLVE: "Resolve",
	RESOLVED: "Resolved",
	DECLINED_REASON: "Declined reason",

	//CONTRACT
	CONTRACT: "Contract",
	CONTRACTS: "Contracts",
	AGREEMENT: "Collective Agreement",
	AGREEMENTS: "Collective Agreements",
	NEW_CONTRACT: "New Contract",
	CREATE_CONTRACT: "Create contract",
	CONTRACT_INVOICE_DAYS: "Invoice days payment",
	CONTRACT_INVOICE_DAYS_PLACEHOLDER: "Invoice days",
	CONTRACT_FALLBACK: "Fallback contract",
	CONTRACT_TERMS: "Terms",
	OB: "OB",
	CONTRACT_SERVICE: "Service",
	CONTRACT_SERVICE_HOURLY_PRICE: "Hourly price (SEK)",
	CONTRACT_SERVICE_VAT: "VAT %",
	CONTRACT_SERVICE_ARTICLE_NUMBER: "Article number",
	CONTRACT_SERVICE_TIME: "Min time per job(h)",
	CONTRACT_PRICE_LIST: "Price list",
	CONTRACT_PRICE_LIST_INFO: "Prislistan hämtas från avtal samt dess eventuella underavtal.", //TODO
	NO_PRICES: "There are no prices",
	NO_CONTRACTS: "There are no any contracts for the search criteria",
	SELECT_CONTRACT: "Select contract",
	RUT_ROT_SETTINGS: "RUT/ROT Settings",
	COMPETENCE_DUPLICATED: "There has two or more price rows for same branch and service",
	OPEN_IN_NEW_TAB: "Open in new tab",
	VALUE_SHOULD_INTEGER: "Value should be integer",

	//JOB
	MORE: "More",
	DELETE_JOB: "Delete job",
	DELETE_JOB_CONFIRM: "Are you sure you want to delete this job?",
	DELETE_INVITATION: "Delete invitation",
	DELETE_INVITATION_CONFIRM: "Are you sure you want to delete this invitation?",
	DELETE_JOB_CONFIRM_BOOKED:
		"Are you sure you want to delete this job? Note that job is already booked.",
	JOB: "Job",
	LONG_TERM: "Long term",
	CUSTOMER: "Customer",
	OVERVIEW: "Overview",
	SCHEDULE: "Schedule",
	EVENTS: "Events",
	CONSULTANTS: "Consultants",
	CANDIDATES: "Candidates",
	MATCHING: "Matching",
	INTERESTED: "Interested",
	VISIBILITY: "Visibility",
	APPLICATION_AND_INVITATIONS: "Application & Invitations",
	INVITED: "Invited",
	SHOW_BOOKED_CONSULTANTS: "Show booked consultants",
	BOOK: "Book",
	DECLINE: "Decline",
	OPEN: "Open",
	REQUESTED: "Requested",
	BRANCH_IS_REQUIRED: "Branch is required",
	SERVICE_IS_REQUIRED: "Service is required",
	SHIFTS_IS_REQUIRED: "Shifts is required",
	JOB_CREATED_SUCCESSFULLY: "Job was created successfully",
	JOB_VIEW_CREATED: "View job",
	SOMETHING_WENT_WRONG: "Something went wrong!",
	DASHBOARD_REFRESH_CACHE_TOOLTIP: "Refresh dashboard cache",
	DASHBOARD_CACHE_REFRESHED: "Dashboard cache is being rebuilt in the background",
	ONE_OR_MORE_ERRORS_IN_FORM: "There are one or multiple errors in form",
	FIX_VALIDATION_ERRORS_BEFORE_SAVING: "Fix validation errors before saving",
	NEW_JOB: "New job",
	CREATE_JOB: "Create job",
	SUBMITTED: "Submitted",
	FROM: "From",
	TO: "To",
	HOURS: "Hours",
	HOURS_SHORT: "Hours",
	EMAIL_IS_REQUIRED: "Email is required!",
	FIRST_NAME_IS_REQUIRED: "First name is required!",
	LAST_NAME_IS_REQUIRED: "Last Name is required!",
	ACCOUNT_NO_IS_REQUIRED: "Account no is required!",
	BANK_NAME_IS_REQUIRED: "Bank name is required!",
	OPEN_CONSULTANT_PROFILE: "Yes, open consultant profile",
	NOT_NOW: "No not now",
	NO_SHIFTS_MESSAGE: "There are no shifts",
	NO_APPLICATION_MESSAGE: "There are no applications or invitations",
	NO_CONSULTANTS_MESSAGE: "There are no matching consultants",
	ABOUT_WORKPLACE: "About the workplace",
	END_DATE_START_DATE_VALIDATION: " can't be before ",
	END_DATE_START_DATE_REQUIRED_VALIDATION: "Start date & end date required",
	END_DATE: "End date",
	NO_JOBS: "There are no jobs that matches the search criteria",
	JOB_DESCRIPTION: "Job description",
	NUM_JOBS: "No jobs",
	SHIFTS_OVERLAP: "is overlapping with another shift",
	SHOW_MORE_WEEKS: "Show more weeks",
	SHOW_PREV_WEEKS: "Show previous weeks",
	BOOKING_TYPE: "Type of booking",
	BOOKING_TYPE_AUTO: "Auto",
	BOOKING_TYPE_OPEN: "Open",
	BOOKING_TYPE_INVITATION: "Invitation",
	CONTACT_PERSON_IS_REQUIRED: "Contact person is required",
	CITY: "City",
	POSTAL_CODE: "Postal code",
	WEEK_NUMBER: "Week number",

	//Consultant
	NEW_CONSULTANT: "New Consultant",
	NEW_AGREEMENT: "New Agreement",
	BANK: "Bank",
	SELECT_BANK: "Select bank",
	BANK_ACCOUNT: "Bank account",
	START_DATE: "Start date",
	EMPLOYMENT_TYPE: "Employment type",
	HOURLY_PAY: "Hourly pay (SEK)",
	TAX_FIELD: "Tax",
	TABLE: "Table",
	TOT_HOURLY_PAY: "Total {{tot}}, valid from {{date}}",
	HOURLY_PAY_INFO: "Hourly pay w/o holiday pay",
	HOLIDAY_PAY: "Holiday pay",
	CREATE_CONSULTANT: "Create consultant",
	CREATE_AGREEMENT: "Create collective agreement",
	BASIC_DETAILS: "Basic details",
	EMPLOYMENT_TYPE_REQUIRED: "Employment type is required!",
	SELECT_EMPLOYMENT_TYPE: "Select employment type",
	SELECT_HOLIDAY_PERCENTAGE: "Select holiday (%)",
	SALARY_DETAILS_REQUIRED: "Enter all salary details",
	TIME_REPORTS: "Time Reports",
	SELECT_ALL: "Select all",
	DESELECT_ALL: "Deselect all",
	CONSULTANT: "Consultant",
	TIME: "Time",
	DIFF_BILLED_TIME: "Diff billed time",
	ACTIVE_CONSULTANT_CREATED_INFO:
		"Do you want to continue to consultant profile to enter more details?",
	INACTIVE_CONSULTANT_CREATED_INFO:
		"Note that consultant is not active, which means that consultant will not show up in matches and be able to login to the app until activated.",
	CONSULTANT_HAS_CREATED: "Consultant has been created",
	CUSTOMER_BLOCK: "Customer block",
	ADD_BLOCK: "Add block",
	ACTIVATE_CONSULTANT_TITLE: "Activate consultant",
	DEACTIVATE_CONSULTANT_TITLE: "Deactivate consultant",
	ACTIVATE_CONSULTANT_TEXT: "Are you sure you want to activate this consultant",
	DEACTIVATE_CONSULTANT_TEXT: "Are you sure you want to deactivate this consultant",
	ACTIVATE_CONSULTANT_WARNING:
		"The consultant is activated. This means that the previous last employment date, YYYY-MM-DD, disappears from the consultant's profile.",
	DEACTIVATE_CONSULTANT_WARNING:
		"The consultant is being disabled. This means that the last employment date is adjusted to today's date, YYYY-MM-DD.",
	DELETE_CONSULTANT: "Delete consultant",
	DELETE_CONSULTANT_TEXT: "Are you sure you want to delete this consultant",
	AVAILABILITY: "Availability",
	STATED_AVAILABILITY: "Stated availability",
	ACTUAL_AVAILABILITY: "Booked availability",
	BOOKING_STATE_BOOKED: "Booked",
	BOOKING_STATE_FREE: "Free",
	TOMORROW: "Tomorrow",
	DAY: "Day",
	MONTH: "Month",
	YEAR: "Year",
	NO_CONSULTANTS: "There are no any consultants for the search criteria",
	NO_BLOCKED_CUSTOMERS: "There is no blocked customers",
	NO_COMPETENCE: "No competences available",
	NO_FEEDBACKS: "No feedbacks available",
	ACTIVATION: "Settings",
	COMPETENCES_UPDATED: "Competences updated",
	INVALID_COMPETENCE: "Invalid competence",
	PROVIDED_CONSULTANT_EMAIL_ALREADY_EXISTS: "Provided consultant email already exists",
	END_DATE_INFO:
		"A specified end date for the employment means that the consultant will be deactivated on this date and will, among other things, then not being able to use their consulting app.",
	SHOW_JOB: "Show Job",
	HIDE_JOB: "Hide Job",
	SHOW_JOB_CONFIRM:
		"Are you sure, you want to show this job? Consultant will be able to see this job",
	HIDE_JOB_CONFIRM:
		"Are you sure, you want to hide this job? Consultant won't be able to see this job",
	DENY_JOB: "Deny Job",
	DENY_JOB_CONFIRM: "Are you sure you want to deny this job?",
	DENY_JOB_SELECT_REASON: "Select a reason for denying this job:",
	DENY_JOB_REASON_OTHER: "Other",
	DENY_JOB_REASON_OTHER_PLACEHOLDER: "Specify reason",
	DENIAL_REASON: "Denial reason",
	DENIAL_REASONS: "Denial reasons",
	DENIAL_REASONS_DESCRIPTION:
		"Reasons that can be selected when a job is denied. Leave empty to not show a reason prompt.",
	DENIAL_REASON_REQUIRED: "Require a reason when denying",
	DENIAL_REASON_ALLOW_OTHER: 'Allow the free-text "Other" option',
	DENIAL_REASON_NAME_PLACEHOLDER: "Reason name",
	DENIAL_REASON_ADD: "Add reason",
	RE_OPEN_JOB: "Reopen Job",
	CANCEL_JOB: "Cancel Job",
	RE_OPEN_JOB_CONFIRM: "Are you sure you want to reopen this job?",
	CANCEL_JOB_CONFIRM:
		"Are you sure you want to cancel the job? Please note that future shifts will be cancelled, but any shifts that already has been started will be kept as is.",
	AGE: "Age",
	OPINION: "Opinion",
	COMMENT: "Comment",
	FEEDBACK_LEFT_BY: "Feedback left by",
	ice: {
		iceName: "ICE contact",
		icePhone: "ICE contact phone",
		iceNamePlaceholder: "",
		icePhonePlaceholder: "",
	},
	AVERAGE_WEEK_TIME: "Average week time",

	//Date Range Picker
	TODAY: "Today",
	YESTERDAY: "Yesterday",
	THIS_WEEK: "This week",
	LAST_WEEK: "Last week",
	THIS_MONTH: "This month",
	LAST_MONTH: "Last Month",
	THIS_YEAR: "This Year",
	LAST_YEAR: "Last Year",
	CUSTOM_RANGE: "Custom Range",
	WEEK_NO: "W",

	//time report status
	ATTESTED_INTERNALLY: "Attested internally",
	APPROVED: "Approved",
	DECLINED: "Declined",
	INVOICED: "Invoiced",
	NOT_WORKED: "Not worked",
	PENDING_REPORT: "Pending report",
	REPORTED: "Reported",
	PLANNED_TIME: "Planned time",
	REPORTED_TIME: "Reported time",
	BREAK: "Break(h)",
	BILLED_TIME: "Billed time",
	DEDUCTION: "Food deduction(SEK)",
	BILLABLE: "Billable",
	NO_TIME_REPORTS: "There are no any time reports for the search criteria",
	PENDING: "Pending",
	INTERNAL_ATTEST: "Internal attest",
	CUSTOMER_ATTEST: "Customer attest",
	SILENT_ATTESTED: "Silent attest",
	ATTEST: "Attest",
	FUTURE_TIME_REPORT: "Upcoming",
	WORKED: "Reported",
	NO_FILTER: "All",

	//Profile picture
	VIEW: "View",
	UPLOAD: "Upload",
	REMOVE: "Remove",

	// recruitment
	RECRUITMENT: "Recruitment",
	IN_REVIEW: "In Review",
	HIRED: "Hired",
	CANCELLED: "Cancelled",
	// PROFILE_APPROVED: "Requirements Profile Approved",
	TAKE_REFERENCES: "Take References",
	INTERVIEW_1: "Interview 1",
	AGREEMENT_EXPIRED: "Agreement Expired",
	AGREEMENT_RECALLED: "Agreement Recalled",
	INTERVIEW_2: "Interview 2",
	// TELEPHONE_INTERVIEW: "Telephone Interview",
	READY_TO_HIRE: "Ready to Hire",
	NEW_APPLICATION: "New Application",
	NOT_CURRENT: "Not Current",
	WAGE_SETTING: "Wage setting",
	CANDIDATE_GETS_BACK: "Candidate gets back",
	REFERENCE_TAKING_AND_CHARGE_REGISTER: "References & Charge register",
	CHARGE_REGISTER: "Charge register",
	// TEST: "Test",
	REFERENCE_TAKING: "Reference Taking",
	INTRODUCTION: "Introduction",
	// EMPLOYMENT_REPORT: "Employment Report",
	NO_THANKS: "No Thanks",
	CANDIDATE_DECLINED: "Candidate Declined",
	NO_THANKS_SENT: "No Thanks Sent",
	AGREEMENT_SENT: "Agreement Sent",
	AGREEMENT_SIGNED: "Agreement signed",
	CREATE_CANDIDATE: "Create Candidate",
	CURRENT_ACTION: "Current Action",
	NEXT_ACTION: "Next Action",
	RECEIVED: "Received",
	NEXT_ACTION_DATE: "Next Action Date",
	RECRUITED: "Recruited",
	NEXT_ACTION_DATE_CHANGED: "Next Action Date Changed",
	INTERVIEW_NOTES_UPDATED: "Interview Note Updated",
	NOTES: "Notes",
	LAST_EDITED: "Last Edited",
	NO_CANDIDATES: "No Candidates",
	MESSAGE_SENT: "Message sent using template",
	NOTE_CHANGED: "Note added",
	BY: "By",
	NO_DATE: "No Date",
	NEW_CANDIDATE: "New Candidate",
	DOCUMENTS: "Documents",
	HISTORY: "History",
	INTERVIEW: "Interview",
	CHANGE_STATUS_TITLE: "Change candidates recruitment status",
	CHANGE_STATUS_TEXT: "Choose where the candidate is in the recruitment process",
	UPDATE_RECRUITMENT_STATUS: "Update",
	CANCEL_RECRUITMENT_STATUS_UPDATE: "Cancel",
	RECRUITMENT_NOTES_ERROR: "Must be 10 characters",
	SEND_MESSAGE_ACTION: "Send message",
	MOVE_TO_CONSULTANT_POOL: "Move to consultant pool",
	SEND_MESSAGE_CANCEL: "Cancel",
	USE_TEMPLATE: "Use template",
	DATE_PICKER_PLACEHOLDER: "Select date & time",
	DOCUMENT_NAME: "Document name",
	DOCUMENT_TYPE: "Document type",
	FILE_FORMAT: "File format",
	DRIVING_LICENSE: "Driving license",
	POLICE_RECORD_EXTRACTS: "Police record extracts",
	VOCATIONAL_IDENTIFICATION: "Vocational identification",
	POLICE_EXTRACT_TYPE: "PRE type",
	POLICE_EXTRACT_TYPE_SCHOOL: "School",
	POLICE_EXTRACT_TYPE_CARE: "Care",
	SELECT_POLICE_EXTRACT_TYPE: "Select PRE type",
	HAS_OVERLAPPING_SHIFTS: "Consultant has overlapping shifts",
	COVER_LETTER: "Cover letter",
	CV: "CV",
	CERTIFICATIONS: "Certifications",
	OTHER_DOCUMENTS: "Other documents",
	OTHER: "Other",
	EXPIRES: "Expires",
	EXPIRE_DATE_PICKER_PLACEHOLDER: "Select date",
	UPLOAD_DOCUMENT: "Upload document",
	UPLOAD_JOB_DOCUMENTS: "Upload documents for the assignment",
	UPLOAD_DOCUMENTS: "Upload documents",
	INTERVIEW_NOTES: "Interview notes",
	INTERVIEW_NOTES_PLACEHOLDER: "Write your note..",
	CHOOSE_A_DOCUMENT_TYPE: "Choose a document type",
	DRAG_AND_DROP_A_FILE: "Drag and drop a file here or",
	BROWSE: "browse",
	TO_UPLOAD: "to upload",
	MAXIMUM_FILE_SIZE: "Maximum file upload size is",
	MAXIMUM_FILE_COUNT: "Maximum file count is",
	MAXIMUM_IMAGE_COUNT: "Maximum image count is",
	MAXIMUM_DOCUMENT_COUNT: "Maximum document count is",
	VALID_FILE_TYPES: "Valid file types => ",
	DELETE_DOCUMENT: "Delete document",
	DELETE_DOCUMENT_TEXT: "Do you want to delete the document",
	NO_DOCUMENT: "No documents available",
	SEND_CONTRACT: "Skicka anställningsavtal",

	mimeTypes: {
		"application/pdf": "PDF",
		"image/jpeg": "JPG",
	},

	//Weekdays
	MONDAY: "Monday",
	TUESDAY: "Tuesday",
	WEDNESDAY: "Wednesday",
	THURSDAY: "Thursday",
	FRIDAY: "Friday",
	SATURDAY: "Saturday",
	SUNDAY: "Sunday",

	//Weekdays short
	MO: "Mo",
	TU: "Tu",
	WE: "We",
	TH: "Th",
	FR: "Fr",
	SA: "Sa",
	SU: "Su",

	WEEKDAYS_CHARS: "M T W T F S S",

	//Internal users
	ORGANISATION_ADMIN: "Organisation admin",
	ORGANISATION_CONSULTANT_MANAGER: "Manager",
	INVITE_USER: "Invite user",
	NO_USERS: "There are no any users for the search criteria",
	SELECT_ROLE: "Select role",
	DELETE_USER: "Delete user",
	DELETE_USER_CONFIRM: "Are you sure you want to delete this user?",
	DEACTIVATE_USER_TITLE: "Deactivate user",
	ACTIVATE_USER_TITLE: "Activate user",
	DEACTIVATE_USER_TEXT: "Are you sure you want to deactivate this user?",
	ACTIVATE_USER_TEXT: "Are you sure you want to activate this user?",

	SUBJECT: "Subject",
	SELECT: "Select",

	//absence
	ABSENCE: "Absence",
	REASON: "Reason",
	REGISTER_ABSENCE: "Register absence",
	CHILD_CARE: "VAB",
	LEAVE_OF_ABSENCE: "Leave of absence",
	SICK_LEAVE: "Sick leave",
	EDIT_ABSENCE: "Edit absence",

	//filters
	ALL: "All",
	NOT_BOOKED_TODAY: "Not booked today",
	NOT_BOOKED: "Not booked",
	NOT_TODAY: "Not today",
	BOOKED: "Booked",
	ACTIVE_BUT_NOT_ARCHIVED: "Active",
	INACTIVE_BUT_NOT_ARCHIVED: "Inactive but not archived",
	ARCHIVED: "Archived",

	// time report filters
	SELECT_CONSULTANT: "Select Consultant",
	SELECT_STATUS: "Select Status",

	KPI_DASHBOARD: "Dashboard",

	//Reports
	REPORTS: "Reports",
	JOB_ID: "Job id",
	RATING: "Rating",
	JOB_REPORTS: "Job Reports",
	WORKED_WITH: "Worked with",
	GOOD_TO_KNOW: "Good to know",
	OVERALL_EXPERIENCE: "Overall experience",
	JOB_REPORT_DETAILS: "Job Report Details",
	FEEDBACK_REPORT: "Feedback Reports",
	SUBMITTED_BY: "Submitted by",
	CONSULTANT_PUNCTUALITY_RATE: "The consultant was punctual",
	CONSULTANT_JOB_RATE: "The consultant did a good job",

	//Invoices
	INVOICES: "Invoices",
	VAT_MUST_BE_POSITIVE: "VAT must be >= 0",

	//Salary
	/** The consultant detail tab showing that consultant's salary over time. */
	SALARY_VIEW: "Salary history",
	/** The salary batch section under Ekonomi. Distinct from SALARY_VIEW. */
	SALARY_SECTION: "Salary",
	SALARY_BATCH: "Salary batch",
	POOL: "Pool",
	NEW_SALARY_BATCH: "New Salary Batch",
	SALARY_PROCESS_MODAL_TITLE: "Salary batch has been created",
	SALARY_PROCESS_MODAL_TEXT:
		"Salary batch was created successfully. You may download  ZIP which contains Hogia files below.",
	DOWNLOAD_FILE: "Download file",
	NOT_NOW_BUTTON: "No, not now",
	SELECT_POOL: "Select Pool",
	SUBSIDIARIES: "Subsidiaries",
	SUBSIDIARY: "Subsidiary",
	BELONGS_TO_SUBSIDIARY: "Belongs to subsidiary",
	NO_SUBSIDIARY: "No subsidiary",
	PREVIEW_SALARIES: "Preview salary",
	SALARY_FOR_PERIOD: "Salary for period",
	SALARY_BREAKDOWN: "Salary Breakdown",
	VIEW_TIME_REPORTS: "View time reports",
	NO_SALARY_PREVIEW: 'Nothing to show here, choose date range and press "Preview"',
	SALARY_JOURNAL: "Salary journal",
	RUN_SALARY: "Run salary",
	CONFIRM_ROLLBACK_SALARY_BATCH: "Are you sure you want to rollback the salary batch?",
	ROLLING_BACK_SALARY_BATCH: "Rolling back...",
	ROLL_BACK_SALARY_BATCH_SUCCESS: "Lönekörningen har rullats tillbaka", //TODO
	TOTAL: "Total",
	MISSING_SALARY_BATCH_INTERVAL: "Ange datum från och till", //TODO
	NUM_CONSULTANTS: "Num. consultants",
	CLEARING_NO: "Clearing No",
	WORKED_HOURS: "Worked Hours",
	BREAK_HOURS: "Break",
	GROSS_SALARY: "Gross Salary",
	TAX: "Tax X%",
	DEDUCTION_AMOUNT: "Deduction",
	TO_PAY: "To pay",

	//Settings
	SETTINGS: "Settings",
	SERVICES_COMPETENCES: "Tjänster", //TODO
	ORG_SETTINGS: "Organisationsinställningar",
	NUMBER_SERIES: "Nummerserier",
	NOTIFICATIONS: "Notifications",
	NOTIF_LOGS: "Nofification logs",
	INTEGRATIONS: "Integrations",
	API_LOGS: "API log",
	RESPONSE_TIME_STATS: "API response time",

	FILTER: "Filter",
	CLEAR: "Rensa",

	pwReset: {
		confirmPassword: "Confirm password",
	},

	contract: {
		name: "Contract name",
		nameDesc: "Only used to identify contract internally",
		invoiceDays: "Invoice days",
		invoiceDaysDesc: "Number of days until invoice should be paid",
		activeDesc: "Activate contract so that it can be connected to customers",
		terms: "Terms",
		termsDesc: "Terms shown to customer during order",
		privateDesc: "Private description",
		privateDescDesc: "Notes only visible internally",
		fallback: "Main contract",
		fallbackDesc: "A contract which this contract inherits from",
		invoiceTemplate: "Invoice template",
		invoiceTemplateDesc:
			"Controls which rows the invoice gets and whether the customer's orders are grouped on one invoice (per customer) or invoiced one by one (per order). Can be overridden per customer. Contact Origo to create or change a template.",
		selectInvoiceTemplate: "Select invoice template",
		archivedInvoiceTemplate: "Archived template",
		rutRot: {
			forRut: "Is eligible for RUT",
			forRot: "Is eligible for ROT",
		},
		delete: {
			success: "Avtalet togs bort",
			failed: "Kunde inte ta bort avtalet",
			confirmTitle: "Är du säker på att du vill ta bort avtalet?",
			confirmText:
				"Genom att ta bort avtalet kommer det inte längre kunna användas för nya kunder.",
		},
		archived: "Archived",
		hidden: "Hide for customers",
		showForCustomers: "Show for customers",
		hideForCustomers: "Hide for customers",
		select: "Select contract",
	},

	login: {
		haveYouForgottenPassword: "Having trouble signing in?",
		email: "Email",
		password: "Password",
		login: "Sign in",
		failed: "Failed to login, please use another username and/or password",
		twoFactorPhoneMissing:
			"Your organisation requires two-factor authentication by SMS, but your account has no mobile number. Ask an administrator to add your number and try again.",
		sessionExpired: "Your session has expired. Please sign in again.",
	},

	activateAccount: {
		title: "Activate your account",
		password: "Choose a password",
		passwordConfirmation: "Confirm password",
		activate: "Activate",
		failed: "Failed to activate account",
		success: "The account has been activated! Press link below to navigate to login.",
		gotoLogin: "Proceed to login",
	},

	deliveryMethod: {
		title: "Delivery method",
		label: {
			E_INVOICE_GLN: "E-invoice (GLN)",
			E_INVOICE_ORG: "E-invoice (org. no.)",
			EMAIL: "Email",
			PRINT: "Print",
		},
		managedByFortnox: "Managed by Fortnox (updated {{date}})",
		privatePersonNoEInvoice: "E-invoice cannot be chosen for private persons",
		timeline: {
			set: "Delivery method set by Fortnox",
			released: "Delivery method no longer managed by Fortnox",
		},
		notConfirmedByFortnox: "Not confirmed by Fortnox",
		eInvoiceIntent:
			"Requested delivery method. The GLN code is sent to Fortnox on the next invoice run – the invoice goes out as Email/Print until the e-invoice connection is active in Fortnox.",
		intentCheck: {
			checking: "Checking the e-invoice connection in Fortnox…",
			notInFortnox:
				"The customer does not exist in Fortnox yet – it is created on the first invoice run",
			inactive: "Not active in Fortnox yet – sent as Email/Print until the connection is active",
		},
		fromCorporateGroup: "Taken from the corporate group",
		missingVatNumber: "The customer has no org. no. — add it under Basic details",
		field: {
			GLNCode: "GLN code (13 digits) is missing",
			GLNFormat: "GLN code must be exactly 13 digits",
			vatNumber: "Org. no. is missing",
			email: "Invoice email address is missing",
		},
		managedMembers_one: "{{count}} member is managed by Fortnox and keeps its own delivery method",
		managedMembers_other:
			"{{count}} members are managed by Fortnox and keep their own delivery method",
		refresh: {
			button: "Fetch from Fortnox",
			description:
				"Reads the customers' delivery method (e-invoice) and GLN from Fortnox and updates the customers in Origo. Also done on every invoice export.",
			success:
				"Fetched from Fortnox {{time}}: {{managed}} customers managed by Fortnox, {{updated}} updated",
			lastRun: "Last fetched {{time}}",
		},
		refreshCustomer: {
			button: "Fetch e-invoice connection from Fortnox",
			saveFirst: "Save your changes first",
			notInFortnox:
				"The customer does not exist in Fortnox yet. It is created on the first invoice run.",
			managed: "Fortnox has an active e-invoice connection for the customer: {{method}}",
			unmanaged: "Fortnox has no active e-invoice connection for the customer",
			updated: "The customer was updated",
			unchanged: "Nothing changed",
		},
	},

	corporateGroup: {
		title: "Corporate group",
		plural: "Corporate groups",
		name: "Corporate group name",
		select: "Search corporate group",
		selectPlaceholder: "Select corporate group",
		create: "Create corporate group",
		createNew: "Create new corporate group",
		edit: "Edit corporate group",
		members: "Customers in the corporate group",
		noMembers: "No customers belong to the corporate group yet",
		memberCount: "Customers",
		empty: "No corporate groups",
		delete: "Delete corporate group",
		deleteBlocked: "The corporate group cannot be deleted while customers belong to it",
		selectRequired: "Select or create a corporate group",
		invoiceDetailsOwnedByGroupTitle: "Heads up",
		invoiceDetailsOwnedByGroup:
			"The customer belongs to a corporate group, invoice details are fetched from the corporate group",
		referenceLabel: "Reference (per customer)",
		customerTypeCompany: "Company",
		customerTypeCorporateGroup: "Company in corporate group",
		customFieldsTitle: "Custom fields",
		customFieldsHint:
			"Applies to every customer in the corporate group and cannot be changed on the customers.",
	},

	customer: {
		name: "Customer",
		namePlaceholder: "",
		invoiceName: "Company name",
		gln: "GLN-kod vid E-faktura",
		invoiceTemplate: "Invoice template",
		invoiceTemplateOverride: "Invoice template (overrides the contract's)",
		costCenter: "Cost centre",
		resultUnit: "Result unit",
		invoiceTemplateFollowContract: "Follow the contract",
		invoiceTemplateDesc:
			"The contract's invoice template is used by default. Pick a template here to give this customer a different row layout.",
		isSignup: "Signed up",
		isSignupPlural: "Signups",
		isSignupShort: "Signups",
		numInactiveSignupsTooltip: "Number of signups that are not yet activated",
		internalNotes: "Internal notes",
		user: {
			invite: "Invite",
			inviteModal: {
				title: "Invite {{name}}",
				text: "The customer will receive an invitation to {{email}} with link to get started.",
				success: "Invitation has been sent",
				failure: "Något gick fel, vänligen försök igen",
				emailLabel: "Send invitation by email {{email}}",
				smsLabel: "Send invitation by SMS {{phoneNo}}",
			},
			removeAccess: {
				title: "Remove access",
				text: "{{name}} will be removed from {{customer}}. Please note that the user still has access to other customers.",
				remove: "Yes, remove access",
			},

			removeUser: {
				title: "Remove user",
				text: "Do you want to remove user {{name}}?",
				remove: "Yes, remove user",
			},
		},
		created: {
			title: "Customer was created",
			infoActive: "You can enter more details by visiting the customers profile.",
			infoInactive:
				"Please note that the customer is not yet activated. This means that the customer cannot login or create any jobs. Change this by visiting the customers profile.",
			yes: "Yes, open customer profile",
			no: "No, not now",
		},
		duplicates: {
			warning: "Found potential duplicate customers",
			hint: "Click on customer to open in new tab",
		},
	},

	job: {
		isBooked: "Booked",
		copy: "Copy",
		hourlyPrice: "Hourly price",
		purchaseOrderNo: "Purchase order num",
		invoiceReference: "Invoice reference",
		invoiceReferenceHint: "Leave empty to use the customer's invoice reference",
		invoiceReferenceHintWithCustomer: "Leave empty for the customer's: {{reference}}",
		customerOrderNo: "Customer order num",
		gflRate: "GFL rate (SEK/h)",
		denied: "Job was denied",
		cancelled: "Job was cancelled",
		deleted: "Job was removed",
		reopened: "Job was reopened",
		createdByCustomer: "Customer created",
		internalNotes: "Internal notes about job",
		shifts: {
			hint: "Press and hold shift to select and edit multiple days in one go.",
			openTimeReports: "Open time reports (opens in new tab)",
			hasWorkedShiftsError: "Job has already started, cannot add shift(s)",
			needsApproveInfo: "One or more shifts needs approval",
			approve: "Accept",
			decline: "Decline",
			add: "Add shift",
			assign: "Assign",
			invalidShift: "Shift is invalid",
			errors: {
				noShifts: "Job needs at least one shift",
				pastInvitations: "Cannot invite consultants to past shifts",
			},
			warnings: {
				absenceModified:
					"One or more shifts which absense applied has been modified, please review the changes. This may affect the consultants VAB and/or sick pay.",
				reportedTimeReportsModified:
					"One or more shifts which has reported time reports has been modified, please review the changes. This may affect the consultants salary.",
			},
		},
		filters: {
			all: "All",
			booked: "All booked",
			notBooked: "Not booked",
			today: "Today",
			notBookedToday: "Not booked today",
			tomorrow: "Tomorrow",
			notBookedTomorrow: "Not booked tomorrow",
			min14Days: "14+ days",
		},
		bookingType: {
			open: "Published",
		},

		doNotPublish: "Do not publish",
		doNotPublishDesc: "Om markerat kommer uppdrag ej synas för konsulter", //TODO
		longTermTag: "+14 days",

		jobStatus: {
			//TODO
			open: "Open",
			booked: "Booked",
			partiallyBooked: "Partially bokad",
			declined: "Declined",
			deleted: "Removed",
			cancelled: "Cancelled",
			accepted: "Accepted",
			acceptedAt: "Accepted {{date}}",
			createdBy: "Published by {{name}}, {{date}}",
			declinedBy: "Declined by {{name}}, {{date}}",
			declinedReason: "Reason: {{reason}}",
			cancelledBy: "Cancelled by {{name}}, {{date}}",
			pending: "Applied",
			applicationDeclined: "Cancelled",
			applicationDenied: "Denied",
			bookedWithUnmannedShifts: "Partly booked",
			booked_with_unmanned_shifts: "Partly booked",
			hidden: "Hidden Job",
		},

		invitationStatus: {
			open: "Invited",
			declined: "Invited - declined",
			expired: "Invited - expired",
		},

		action: {
			acceptApplication: "Book consultant",
			cancelApplication: "Cancel",
			book: "Book",
			bookAll: "Book all",
			decline: "Decline",
			inviteAll: "Invite all",
			uninviteAll: "Remove all invitations",
		},

		customerExperience: "Previous experience",
		customerExperienceShort: "Prev exp",

		application: {
			createdBy: "Applied {{date}}",
			acceptedBy: "Booked by {{name}} {{date}}",
			accepted: "Booked {{date}}",
		},
		notifyMatchingConsultants: "Notify consultants",
		consultantWasBooked: "Consultant was booked",
		applicationWasDeclined: "Application was declined",
		consultantWasUnbooked: "Consultant was unbooked",
		flag: "Flag",
		contactPerson: "Contact Person",
		invite: "Invite",
		invited: "Invited",
		inviteAgain: "Invite again",
		inviteDeclined: "Has declined",
		hasApplied: "Has applied for shift(s)",
		sendingInvitations: "Sending invitations",
		invitationsSent: "Invitations has been sent",
		invitationsFailed: "The invitations could not be sent",
		invitationsPartiallyFailed: "{{failed}} of {{total}} invitations could not be sent",
		invitationDeleted: "Invitations has been deleted",
		matchJobsCompetence: "Match job",
		inviteInfo: "Select consultant(s) to invite.",
		inviteRequiredFields:
			"You need to set customer, competence and shift(s) in order to match consultant that can be invited.",
		inviteInstructions: "Select consultants to invite in next step after job has been created.",
		copyInfo: "Copy of job #{{orderNumber}}",
		downloadOrderConfirmationCustomer: "Download order confirmation (customer)",
		downloadOrderConfirmationConsultant: "Download order confirmation (consultant)",
		orderConfirmationError: "Cannot download order confirmation, is the job booked?",
		pdfTemplateMissing:
			"No PDF template is configured for the organisation. Create it under Settings → Notifications.",
	},

	reports: {
		excelExports: "Excel export",
		customerReport: "Customers",
		customerContactReport: "Customer contacts",
		consultantReport: "Consultants",
		candidateReport: "Candidates",
		consultantWorkedHoursReport: "Consultant's worked hours",
		soldHoursAndRevenueReport: "Sold hours and Revenue",
		dashboards: "Dashboards",
		newDashboard: "New dashboard",
		sharedWithMe: "Shared with me",
		noDashboards: "You have no dashboards yet. Create one with the plus button.",
		unnamedDashboard: "Unnamed dashboard",

		customerReportTitle: "Customers report",
		customerContactReportTitle: "Customer contacts report",
		consultantReportTitle: "Consultants report",
		candidateReportTitle: "Candidates report",
		consultantWorkedHoursReportTitle: "Consultant's worked hours report",
		soldHoursAndRevenueReportTitle: "Sold hours and Revenue report",

		download: "Download",
		export: "Export",
		filters: {
			certification: {
				label: "Certification",
				placeHolder: "All",
			},
			certificationStatus: {
				label: "Status",
				placeHolder: "All",
				options: {
					valid: "Valid",
					expired: "Expired",
					missing: "Missing",
				},
			},
			certificationExpiresBy: {
				label: "Expires by",
				placeHolder: "Select date",
			},
			branch: {
				label: "Branch",
				placeHolder: "All",
			},
			service: {
				label: "Service",
				placeHolder: "All",
			},
			startDate: {
				label: "Start date",
				placeHolder: "Select start date",
			},
			endDate: {
				label: "End date",
				placeHolder: "Select end date",
			},
			range: {
				label: "Range",
				placeHolder: "Start and end",
			},
			pool: {
				label: "Pool",
				placeHolder: "Select pool",
			},
			contract: {
				label: "Contract",
				placeHolder: "Select contract",
			},
			customer: {
				label: "Customer",
				placeHolder: "Select customer",
			},
			status: {
				label: "Status",
				placeHolder: "Select status",
			},
			currentAction: {
				label: "Current action",
				placeHolder: "Select current action",
			},
			jobStatus: {
				label: "Job status",
				placeHolder: "Select status",
				options: {
					open: "Open",
					booked: "Booked",
					partiallyBooked: "Partially booked",
					declined: "Declined",
					deleted: "Deleted",
					cancelled: "Cancelled",
				},
			},
			statusTypes: {
				options: {
					active: "Active",
					inActive: "Inactive",
				},
			},
		},
		soldHourHelpText:
			"Bokade eller nekade timmar per uppdrag / skift.\nI första hand prioriteras fakturerad tid, i andra hand tidrapporterad och i tredje bokad/ beställd tid.\nI första hand används fakturerat timpris, i andra hand senaste fakturerade timpriset och i tredje hand timpriset vid bokningstillfället.\nRaderade uppdrag eller ej utförda skift från avbrutna uppdrag redovisas inte.",
	},

	invoice: {
		invoice: "Invoice",
		invoiceNumber: "Invoice number",
		internalInvoiceNumber: "Internal invoice number",
		invoiceDate: "Invoice date",
		dueDate: "Due date",
		customer: "Customer",
		total: "Total",
		runInvoices: "New invoice batch",
		totalInclVat: "Total (incl. VAT)",
		totalExclVat: "Total (excl. VAT)",
		invoiceBatches: "Invoice batches",
		invoiceBatch: "Invoice batch",
		description: "Description",
		quantity: "Quantity",
		price: "Price",
		sum: "Sum",
		vat: "Vat",
		toPay: "To pay",
		address: "Address",
		roundOff: "Rounding",
		exclVat: "Exkl. VAT",
		net: "Net",
		downloadPdf: "Download PDF",
		createCredit: "Credit invoice",
		yourReference: "Your reference",
		costCenter: "Cost centre",
		confirmDeleteRow: "Are you sure you want to remove the invoice row?",
		credit: {
			// TODO
			credit: "Kreditfaktura",
			confirm: "Är du säker på att du vill skapa en kreditfakturan?",
			fortnoxInfo: "En kreditfaktura kommer skapas i Fortnox.",
			loading: "Skapar kreditfaktura...",
			failed: "Kunde inte skapa kreditfaktura",
			success: "Kreditfaktura #{{creditInvoiceNum}} skapades",
			invoiceNotBookKept: "Kan ej skapa kreditfaktura när fakturan ej är bokförd i Fortnox",
			invoiceAlreadyCredited: "Fakturan är redan markerad som krediterad i Fortnox",
		},
		credited: "Credited",
		template: "Template",
		timeReportsOnRow: "time reports on this row",
		downloading: "Retrieving invoice...",
		downloadFailed:
			"Failed to retrieve PDF invoice, make sure that invoice exists in invoicing system",
		journal: {
			// TODO
			pool: "Pool",
			numInvoices: "Antal fakturor",
			invoiceJournal: "Fakturajournal",
			to: "Till och med",
			invoiceDate: "Fakturadatum",
			invoiceNum: "Fakturanr",
			customer: "Kund",
			dueDate: "Förfallodatum",
			exclVAT: "Exkl. moms",
			inclVAT: "Inkl. moms",
			perService: "Per tjänst",
		},
	},

	/** Shared by the invoice and salary batch filters. */
	batchFilter: {
		/** Batch list column header. Shows the whole scoping, not just the pool. */
		scopeColumn: "Selection",
		/** "No constraint" row of the inline pool checkbox group. */
		allPools: "All",
		/** "No constraint" row of the inline subsidiary checkbox group. */
		allSubsidiaries: "All",
		noSubsidiary: "None (directly to the organisation)",
	},
	batchIssues: {
		showAll: "Show all ({{count}})",
		hide: "Hide",
	},
	batchStaleness: {
		title: "The underlying data has changed",
		info: "Time reports changed after this preview was computed ({{details}}). Refresh the preview to recompute it.",
		added_one: "{{count}} new time report",
		added_other: "{{count}} new time reports",
		changed_one: "{{count}} changed",
		changed_other: "{{count}} changed",
		removed_one: "{{count}} removed",
		removed_other: "{{count}} removed",
	},
	batchRefresh: {
		button: "Refresh preview",
		confirmDiscardEdits:
			"Manual changes to the draft (deselected rows and added items) will be lost when the preview is refreshed. Continue?",
		success: "Preview refreshed",
		failed: "Could not refresh the preview",
	},
	invoiceBatch: {
		invoiceBatches: "Invoice batches",
		invoiceBatch: "Invoice batch",
		to: "To date",
		toDescription: "Time report to and including this date will be included in the invoice batch.",
		new: "New invoice batch",
		newLikeThis: "New batch with the same selection",
		invoiceDateDescription: "Invoice date set for all generated invoices.",
		submit: "Preview",
		issues: "",
		filter: {
			customerTags: "Customer tags",
			addTag: "Select customer tag",
			searchTag: "Search customer tag…",
			addContract: "Select contract",
			searchContract: "Search contract…",
			advanced: "Advanced",
			customFields: "Custom fields",
			advancedSelection: "Advanced selection",
			allPools: "All",
			customers: "Customers",
			searchCustomer: "Search customer…",
			excludedCustomers: "Excluded customers",
			excludedCustomersCount_one: "{{count}} customer manually excluded",
			excludedCustomersCount_other: "{{count}} customers manually excluded",
			selectedCustomers:
				"{{selected}} of {{total}} customers selected · {{timeReports}} time reports",
			timeReports_one: "{{count}} time report",
			timeReports_other: "{{count}} time reports",
			noCustomers: "No customers match the selection",
			readOnlySelection: "{{included}} customers included · {{excluded}} manually excluded",
			excludedRow: "Manually excluded",
			done: "Done",
		},
		scope: {
			heading: "Current selection:",
			customers_one: "{{count}} customer",
			customers_other: "{{count}} customers",
			attestedTimeReports_one: "{{count}} attested time report",
			attestedTimeReports_other: "{{count}} attested time reports",
			empty: "No attested time reports match your selection",
		},
		showInvoiceJournal: "Invoice journal",
		cancel: "Ta bort", //TODO
		process: "Run invoices",
		moreActions: "More actions",
		emptyState: {
			notSubmitted: "Select date for invoice batch and press 'Preview' to generate invoices",
			noContent: "There are no invoices for provided date",
		},
		error: {
			submit: "Something went wrong when invoice batch was being created",
			INVOICE_BATCH_HAS_NO_CUSTOMERS:
				"Failed to create invoice batch, there are no valid customers",
			failedToRetrieve: "Something went wrong while dowloading invoice batch",
			NOT_FOUND: "Not found",
		},
		issue: "{{count}} issues detected",
		issueInfo: "Invoices related to below issues has not been included in invoice batch:",
		warningsTitle_one: "{{count}} warning",
		warningsTitle_other: "{{count}} warnings",
		warningsInfo:
			"The following were left out of the batch. Unattested time reports are picked up by a later run once attested:",
		issueType: {
			CUSTOMER_IS_INACTIVE: "Customer is not activated",
			CUSTOMER_IS_NOT_COMPLETED: "Customer profile is missing invoice details",
			TIME_REPORT_NOT_ATTESTED: "Time report is not attested",
			INVALID_GLN_CODE: "The customer's GLN code is invalid (must be 13 characters)",
			DELIVERY_METHOD_INCOMPLETE: "The customer's delivery method is missing details",
			INVOICE_GENERATOR: "The invoice template skipped or duplicated time reports",
			CUSTOMER_SKIPPED_BY_TEMPLATE:
				"The invoice template left the customer out of the invoice batch",
			PREVIEW_ERROR: "Something went wrong while creating the draft",
		},
		issueDescription: {},
		skippedTimeReports_one: "{{count}} time report waits for the next batch",
		skippedTimeReports_other: "{{count}} time reports wait for the next batch",
		status: {
			INITIAL: "Initial",
			PREVIEW: "Preview",
			ROLLED_BACK: "Rolled back",
			PROCESSED: "Processed",
			FAILED: "Failed",
			PROCESSING: "Processing",
		},
		confirmRollback: "Are you sure you want to rollback the invoice batch?",
		confirmDelete: "Are you sure you want to remove the invoice batch?",
		confirmRollbackAndRemove: "Are you sure you want to remove the invoice batch?",
		rollbackAndRemoveSuccess: "Invoice batch was removed",
		rollbackSuccess: "Invoice batch was rolled back",
		rollbackFailed: "Could not roll back the invoice batch",
		rollingBack: "Rolling back...",
		numInvoices: "Num invoices",
		rollbackNotSupported:
			"The invoice batch cannot be rolled back because its invoices already exist in Visma. Follow up on individual invoices instead.",
		exportSummary: {
			failed_one: "{{count}} failed",
			failed_other: "{{count}} failed",
			held_one: "{{count}} to check",
			held_other: "{{count}} to check",
			attachmentMissing_one: "{{count}} without specification",
			attachmentMissing_other: "{{count}} without specification",
		},
		exportBanner: {
			failed_one:
				"{{count}} invoice was not created in Visma. Its time reports are released and will be included in a new invoice batch.",
			failed_other:
				"{{count}} invoices were not created in Visma. Their time reports are released and will be included in a new invoice batch.",
			held_one:
				"{{count}} invoice may have been created in Visma. Check in Visma and record the outcome below; the time reports are held until then.",
			held_other:
				"{{count}} invoices may have been created in Visma. Check in Visma and record the outcome below; the time reports are held until then.",
			attachmentMissing_one:
				"{{count}} invoice is missing its specification in Visma. Attach the PDF manually in Visma.",
			attachmentMissing_other:
				"{{count}} invoices are missing their specification in Visma. Attach the PDF manually in Visma.",
			released:
				"Time reports from invoices that were not created are released and will be included in a new invoice batch.",
		},
		exportStatus: {
			column: "Status in Visma",
			FAILED: "Failed",
			HELD: "Check in Visma",
			ATTACHMENT_MISSING: "Specification missing",
			RELEASED: "Not in Visma",
			CONFIRMED_EXPORTED: "Exists in Visma",
			ATTACHMENT_RESOLVED: "Specification resolved",
			resolvedAt: "Resolved {{date}}",
			attachmentHelp:
				"The invoice exists in Visma. Attach the specification (PDF) manually in Visma.",
			notInVisma: "Not in Visma",
			inVisma: "Exists in Visma",
			markResolved: "Mark as resolved",
			invoiceNumber: "Invoice no. {{invoiceNumber}}",
			releaseDialog: {
				title: "The invoice does not exist in Visma",
				description:
					"Confirm that you have checked in Visma that the invoice to {{customer}} was not created. The time reports are released and will be included in the next invoice batch.",
				confirm: "Release time reports",
			},
			confirmDialog: {
				title: "The invoice exists in Visma",
				description:
					"Enter the invoice number the invoice to {{customer}} got in Visma. The invoice is then marked as created.",
				invoiceNumber: "Invoice number in Visma",
				required: "Enter the invoice number",
				confirm: "Save",
			},
			success: {
				released: "The time reports are released",
				confirmed: "The invoice is marked as created in Visma",
				attachmentResolved: "Marked as resolved",
			},
			actionFailed: "Could not save. Reload the page and try again.",
		},
		dryRun: {
			button: "Test run",
			buttonHint:
				"Checks the invoice batch against the invoice system without writing anything. No invoice numbers are claimed.",
			alreadyRunning: "A test run is already in progress for this invoice batch",
			startFailed: "Could not start the test run",
			title: "Test run",
			running: "Test run in progress...",
			startedAt: "Started {{date}}",
			ranAt: "Ran {{date}}",
			ranAtBy: "Ran {{date}} by {{name}}",
			outdated: "Outdated",
			outdatedInfo:
				"The invoice batch has changed since the test run. Run the test again for a current result.",
			errorTitle: "The test run could not be completed",
			errorInfo:
				"The check stopped before it finished, so the result says nothing about the invoices. Nothing was written to the invoice system. Try again.",
			resultErrors: "The test run found errors",
			resultWarnings: "The test run found warnings",
			resultClean: "The test run found no errors or warnings",
			notAGuarantee:
				"A clean test run is not a guarantee. The invoice system's own validation only runs when the invoices are created.",
			invoicesChecked_one: "{{count}} invoice checked",
			invoicesChecked_other: "{{count}} invoices checked",
			invoicesWithErrors_one: "{{count}} with errors",
			invoicesWithErrors_other: "{{count}} with errors",
			invoicesWithWarnings_one: "{{count}} with warnings",
			invoicesWithWarnings_other: "{{count}} with warnings",
			batchFindings: "Applies to the whole invoice batch",
			invoiceFindings: "Per invoice",
			severity: {
				error: "Error",
				warning: "Warning",
			},
			showInvoice: "Show in list",
			showDetails: "Show details",
			hideDetails: "Hide details",
			tenant: "Company {{tenantId}}",
			plannedWrites: "Would be written to the invoice system",
			customersToCreate_one: "{{count}} customer is created",
			customersToCreate_other: "{{count}} customers are created",
			customersToUpdate_one: "{{count}} customer is updated",
			customersToUpdate_other: "{{count}} customers are updated",
			changedFields: "Changes: {{fields}}",
			articlesToCreate_one: "{{count}} article is created",
			articlesToCreate_other: "{{count}} articles are created",
			subaccountsToCreate_one: "{{count}} subaccount is created",
			subaccountsToCreate_other: "{{count}} subaccounts are created",
			notChecked: "Could not be checked",
			rowMarker: {
				error: "The test run found errors on this invoice",
				warning: "The test run found warnings on this invoice",
			},
			confirmProcess:
				"The latest test run found errors. Invoices with errors may be rejected by the invoice system or stop the run. Create the invoices anyway?",
			processingModal: {
				loading: "Test running the invoice batch...",
				loadingInfo:
					"Reading from the invoice system and checking the invoices. Nothing is written and no invoice numbers are claimed. This can take a few minutes depending on the number of invoices.",
				done: "The test run is finished",
				doneInfo: "The result is shown above the invoices.",
				failure: "The test run could not be completed",
			},
		},
		processingModal: {
			// TODO
			loading: "Skapar fakturor...",
			loadingInfo:
				"Anropar fakturasystem. Detta kan ta upp till några minuter beroende på mängd fakturor i fakturakörning.",
			failure: "Fakturakörningen kunde ej genomföras",
			processed: "Fakturakörningen genomfördes",
			log: "Visa loggutskrifter ({{count}})",
			createdCustomers: "{{count}} kunder skapades",
			updatedCustomers: "{{count}} kunder uppdateras",
			processingWarnings: "Show warnings ({{count}})",
			partial: "The invoice batch was completed with deviations",
			partialInfo: "The following invoices need follow-up:",
			showBatch: "Show invoice batch",
		},
		showProcessingResult: "Detailed information about export (advanced)",
	},

	salary: {
		submitFailure: "Failed to retrieve salary for period",
		submitFailure404: "There are no time reports for period",
		creatingPreview: "Creating salary preview...",
		previewReady: "Salary preview is ready",
		previewFailed: "Failed to create salary preview",
		start: "Start date",
		end: "End date",
		breakdown: {
			hourly: "Hourly wage",
			holidayPay: "Holiday pay",
			childCare: "Child care",
			sickPay: "Sick pay day 1-14",
			sickPayNonPaid: "Sick day 15+",
			qualifyingDeduction: "Qualifying deduction",
			leaveOfAbsence: "Leave of absence",
		},
		journal: {
			all: "All",
			quantity: "Quantity",
			award: "Award",
			amount: "Amount",
			numberOfPeople: "Number of People",
			salaryPeriod: "Salary period",
			salaryJournal: "Salary journal",
			byTypeOfSalary: "By type of salary",
			noData: "No data available",
			print: "Print",
			salaryTypes: {
				hourly: "Hourly wage",
				deduction: "Deduction",
				sickPay: "Sick pay day",
				sickPayNonPaid: "Sick non pay day",
				qualifyingDeduction: "Qualifying deduction",
				leaveOfAbsence: "Leave of absence",
				childCare: "Child care",
				holidayPay: "Holiday pay",
				ob: "OB",
				ob1: "OB1",
				ob2: "OB2",
				ob3: "OB3",
				ob4: "OB4",
				ob5: "OB5",
			},
		},
		hourlyPay: "Hourly pay",
		ob: "OB supplement",
		qualifyingDeduction: "Qualifying deduction",
		grossSalary: "Gross salary (before tax)",
		sickPay: "Sick pay",
		totalHours: "Total booked hours",
	},

	salaryBatch: {
		success: {
			fortnox: "Consultants and salaries were exported to Fortnox",
			hogia: "Files including person data and salaries has been created and is ready for download",
		},
		issue: "{{count}} issues detected",
		issueInfo: "Salaries related to below issues has not been included in salary batch:",
		warningsTitle_one: "{{count}} warning",
		warningsTitle_other: "{{count}} warnings",
		warningsInfo: "The following were left out of the salary batch:",
		issueType: {
			MISSING_CONSULTANT_BANK_DETAILS: "Consultant is missing required bank details",
			MISSING_CONSULTANT_SALARY_DETAILS: "Consultant is missing required salary details",
			TIME_REPORT_NOT_ATTESTED: "Time report is not attested",
			INVALID_PERSONAL_NUMBER: "Invalid personal number",
			PREVIEW_ERROR: "Something went wrong while creating the draft",
		},
		status: {
			INITIAL: "Creating",
			PREVIEW: "Draft",
			ROLLED_BACK: "Cancelled",
			PROCESSED: "Processed",
			FAILED: "Invalid",
			PROCESSING: "Processing...",
		},
		processingModal: {
			loading: "Creating salaries...",
			loadingInfo:
				"Calling salary system. This may take a few minutes depending on the number of salaries.",
			failure: "Failed to process salary batch",
			processed: "Salary batch processed",
			log: "Show log prints ({{count}})",
			createdEmployees: "{{count}} consultants created in the employee registry",
			updatedEmployees: "{{count}} consultants updated in the employee registry",
			processingWarnings: "Show warnings ({{count}})",
		},
	},

	timeReports: {
		updateSuccess: "Time report was updated",
		reportedTimeHelp: "Time consultant has reported. Is used for salary.",
		billedTimeHelp:
			"Time that will be invoiced to customer. If nothing else is set, the same time as reported will be used.",
		billableTime: "invoiceable time",

		listStatus: {
			SICK_LEAVE: "Sick leave",
			LEAVE_OF_ABSENCE: "Leave of absence",
			CHILD_CARE: "Child care",
		},
		bulkAttest: {
			attest: "Attestera",
			info: "Vill du attestera {{count}} tidrapport(er)?",
			warning:
				"OBS! En eller flera av de markerade tidrapporterna är ej redo att attesteras och kommer därmed inte ändras",
			loading: "Attesterar {{count}} tidrapport(er)",
			success: "Tidrapporterna attesterades",
			partial: "{{updated}} attesterades, {{failed}} kunde inte attesteras",
			error: "Tidrapporterna kunde inte attesteras",
		},
		bulkPublish: {
			publish: "Publicera",
			info: "Vill du publicera {{count}} tidrapport(er)?",
			warning:
				"OBS! En eller flera av de markerade tidrapporterna är ej redo att publiceras och kommer därmed inte ändras",
			loading: "Publicerar {{count}} tidrapport(er)",
			success: "Tidrapporterna publicerades",
		},
		selectDateRange: "Välj datum",
		selectedRows: "{{count}} row",
		selectedRows_plural: "{{count}} rows",
		pendingPublish: "Not pubished",
		publish: "Publish",
		undoResolve: "Undo resolve",
	},

	absence: {
		reason: "Absence",
		type: {
			SICK_LEAVE: "Sick leave",
			LEAVE_OF_ABSENCE: "Leave of absence",
			CHILD_CARE: "Child care",
		},
		delete: {
			title: "Delete absence",
			text: "Are you sure you want to remove absence?",
			warning: {
				title: "Absence used in salary/invoice",
				text: "This absence has time reports that have already been salary-processed or invoiced. Do you still want to delete it?",
				confirm: "Delete anyway",
			},
		},
	},

	recruitment: {
		sendMessage: {
			subject: "Subject",
			message: "Write your message...",
			success: "The message has been sent",
		},
		moveToConsultantPool: {
			confirmationText: "Are you sure you want to add the candidate as a consultant?",
			cancel: "Cancel",
			yes: "Yes",
		},
		sendContractModal: {
			title: "Are you sure you want to send the contract?",
			text: "The employment contract will be delivered to candidate for signing. Select how you want to deliver the invitation.",
			emailLabel: "Send via email {{email}}",
			smsLabel: "Send via SMS {{phoneNo}}",
			success: "Contract was sent to {{email}}",
			missingDetails:
				"Candidate must have personal identification number and salary information specified in order to send a contract.",
		},
		adId: "Ad",
		removeCandidate: "Remove candidate",
		created: "Candidate was created",
		otherNotes: "Misc notes",
		bulk: {
			selected: "candidates selected",
			recipients: "candidates",
			sendMessage: "Send message",
			updateAction: "Update activity",
			clearSelection: "Clear selection",
		},
	},

	customers: {
		user: {
			errors: {
				cannotDeleteLast: "Det måste alltid finnas minst en användare på kunden.",
			},
			autoComplete: {
				placeholder: "Select user to add",
			},
			noUsers: "Customer does not have any users",
			confirmAdd: {
				title: "Are you sure?",
				text: "The user will be able to login and make order on behalf of the customer.",
			},
		},
		customerNumberShort: "Customer num",
		multipleCustomers: {
			access: "Has access to multiple customers",
			name: "Name",
			customerNumber: "Customer Number",
			notifications: "Notifications",
			addCustomer: "Add customer",
			cancel: "Cancel",
			noCustomers: "No Customers available",
			notificationTypes: {
				booking: "Booking confirmation notifications",
				timeReport: "Time report notifications",
				jobReport: "Job report notifications",
			},
			errors: {
				emptyCustomer: "Please select a customer",
			},
			add: "Lägg till kund",
			info: "Manage which customers the user has access to and their notification settings.",
			notificationSettingsTitle: "Notification settings",
		},
	},

	// TODO
	sendNotificationModal: {
		title: "Send notifications",
		info: "Ange meddelande som skickas till konsulter som matchar uppdraget. Meddelandet skickas som push-notis till konsultens mobilapp.",
		placeholder: "max 200 tecken",
		success: "Meddelandet skickades",
	},

	// TODO
	consultant: {
		invite: "Bjud in",
		employeeNumber: "Employee number",
		salary: {
			supplement: "Salary supplement",
			hourlySupplement: "Hourly supplement",
			hourlySupplementTot: "Total hourly pay {{tot}}",
			hourlySupplementTotWithHolidayPay: "Total incl. holiday pay {{tot}}",
			save: "Update salary",
			current: "current",
			validFrom: "Valid from {{date}}",
			history: "Salary history",
		},
		shifts: {
			jobsAndApplications: "Uppdrag och ansökningar",
			empty: "Consultant does not have any jobs or application",
		},
		address: {
			city: "Ort",
		},
		doNotPublish: "Do not publish matching jobs",
		doNotPublishDesc: "Consultant will not be able to see any matching jobs in the app",
		activateDesc:
			"By activating the account the consult will be matched and able to login to the app",
		autoComplete: {
			placeholder: "Search consultant",
		},
		title: "Title",
		union: "Union",
		collectiveAgreement: "Collective agreement",
		collectiveAgreementPlaceholder: "Select collective agreement",
		employmentOptions: {
			pension: "After retirement, +65 years of age",
			student: "Student",
			otherMainEmployment: "Other main employment",
			title: "Employment options",
		},
		sendEmploymentCertificate: "Send to Arbetsgivarintyg.nu",
		sendContract: "Send contract",
		sendContractTitle: "Send contract to {{name}}",
		sendContractText: "Send employment contract for signing with BankID.",
		sendContractSuccess: "Contract has been sent",
		sendContractMissingDetails: "Consultant is missing email, social security number, or salary",
		employment: {
			started: "Start date",
			ended: "End date",
			firstStarted: "Initial start date",
		},
	},

	collectiveAgreement: {
		showAssignedConsultants: "Show assigned consultants",
		assignedConsultants: "Assigned consultants",
		noAssignedConsultants: "No consultants assigned to this collective agreement",
		updateGuaranteedHours: {
			title: "Update Collective Agreement",
			usedByConsultants: "This collective agreement is used by {{count}} consultant.",
			usedByConsultants_plural: "This collective agreement is used by {{count}} consultants.",
			autoUpdate:
				"All consultants using this agreement will be automatically updated with the new guaranteed hours and salary values.",
			updateAgreement: "Update Agreement",
		},
	},

	// TODO
	organisation: {
		notifications: {
			push: "Pushnotis",
			email: "Email",
			emailTemplate: "Email template",
			emailTemplateDesc: "Sendgrid template ID",
			pushDesc: "Max ~150 chars",
			editTemplate: "Edit",
			emailLayout: "Email base layout",
			emailLayoutDesc: "Base layout for email template",
			emailSubject: "Email subject",
			sendTest: "Send Test",
			sendTestModalTitle: "Send Test",
			sendTestDescription: "Enter an email address to send a test notification.",
			userEmailPlaceholder: "Email address",
			templatePreview: "Template preview:",
			testSent: "Test notification sent",
			userNotFound: "User not found. Please check the email address.",
		},
		economy: {
			cfar: "CFAR-nummer",
			cfarDescription:
				"CFAR-nummer som anges vid lönekörning. Lämna tomt om inget CFAR-nummer ska anges.",
			cfarUpdated: "CFAR-nummer uppdaterades",
		},
		defaultContract: {
			updated: "Standardavtalet uppdaterades",
		},
		subsidiaries: {
			title: "Subsidiaries",
			description:
				"Manage the organisation's subsidiaries. A subsidiary's name, organisation number, address, employment contract and pools override (fall back on) the organisation's values.",
			add: "Add subsidiary",
			edit: "Edit subsidiary",
			empty: "No subsidiaries have been added yet.",
			name: "Name",
			orgNo: "Organisation number",
			address1: "Address",
			careOf: "C/O",
			postalCode: "Postal code",
			city: "City",
			cfar: "CFAR number",
			cfarDescription: "CFAR number for the subsidiary. Not yet used during salary processing.",
			recruitmentContract: "Employment contract (template)",
			recruitmentContractDescription:
				"Handlebars template that overrides the organisation's template when a consultant in this subsidiary is employed. Leave empty to use the organisation's template.",
			pools: "Pools",
			poolsDescription:
				"Pools available to the subsidiary's consultants (a subset of the organisation's pools). Leave empty to allow all organisation pools.",
			deleteConfirmTitle: "Delete subsidiary",
			deleteConfirm: "Are you sure you want to delete this subsidiary?",
			deleteBlocked:
				"The subsidiary cannot be deleted while consultants or customers are connected to it.",
			deleted: "Subsidiary deleted",
		},
	},

	shiftCal: {
		selectWeek: "Select week",
		deselectWeek: "Deselect week",
	},

	customerBlock: {
		comment: "Private comment",
	},

	schedule: {
		schedule: "Schedule",
		byConsultant: "By consultant",
		byCustomer: "By customer",
		selectDateRange: "Select period",
		filterConsultant: "Consultant",
		filterConsultantManager: "Manager",
		filterCustomer: "Customer",
		filterContract: "Contract",
		includeUnbooked: "Show unbooked consultants",
	},

	datePicker: {
		time: "Time",
		timePlaceholder: "hh:mm",
		select: "Select date",
		timeShortcuts: "Shortcuts",
	},

	inviteModal: {
		title: "Invite {{name}}",
		text: "The user will receive an invitation sent with a link to a form where they can enter their password and instructions on how to get started.",
		success: "Invitation has been sent",
		failure: "Something went wrong",
	},

	error: {
		DELIVERY_METHOD_INCOMPLETE: "The delivery method is missing details",
		DELIVERY_MANAGED_BY_FORTNOX:
			"Delivery method and GLN code are managed by Fortnox and cannot be changed in Origo",
		INVALID_GLN_CODE: "GLN code must be exactly 13 digits",
		ACCEPTED_CONSULTANT_SHIFT_OVERLAP:
			"One or more shift(s) overlaps with shift from other job which consultant is booked on",
		HAS_WORKED_SHIFT: "Cannot edit shift when work has started and is reported",
		LAST_USER_OF_CUSTOMER_CANNOT_UPDATE: "Cannot remove user, customer must have at least one user",
		PRICE_CANNOT_CALCULATE: "Failed to calculate prices for the provided competence",
		ORDER_NUMBER_ALREADY_EXISTS: "Order number already exists",
		CONSULTANT_IS_INACTIVE: "Consultant is not activated",
		CONSULTANT_NOT_AVAILABLE: "Consultant is no longer available",
		INVALID_SOCIAL_SECURITY_NUMBER:
			"The consultant has no valid personal number. The contract is locked to the consultant's personal number for signing — please check and correct it in the profile.",
		BAD_REQUEST: "Something went wrong (400)",
		SCHEDULE_CONFLICT: "Consultant is already booked on another job",
		ABSENCE_HAD_USED:
			"Cannot delete absence as timeport(s) has been used for invoicing and/or salary",
		MISSING_POLICE_EXTRACT:
			"Cannot book — consultant has no valid police record extract for this branch",
	},

	consultantTag: {
		hoursLeft: "{{count}} h left",
		renew: "Renew ({{hours}} h)",
		remove: "Remove",
	},

	contactMenu: {
		call: "Call {{phone}}",
		callShort: "Call",
		message: "Send message",
		gotoProfile: "Open profile",
		gotoCustomer: "Open customer",
		gotoJob: "Open job",
		createJob: "Create job",
		settings: "Settings",
		tags: "Tags",
		contactPersons: "Contact persons",
		noContactPersons: "No contact persons",
		noContactDetails: "No contact details",
		copyPhone: "Copy phone number",
		copyEmail: "Copy email",
		copied: "Copied",
	},

	jobReport: {
		ratingNotSet: "Not set",
		period: "Period",
	},

	updateToast: {
		title: "New version available",
		description: "A new version of Origo is available. Press to update.",
		button: "Update",
	},
	effortRating: "Behaviour",
	punctualityRating: "Punctuality",
	showConsultants: "Shown for consultants within",
	publishDocuments: "Publish documents",
	updateDocuments: "Update documents",
	ADD_LINK: "+ Add Link",
	LINK: "Link",
	UPLOAD_FILE: "+ Upload File",
	UPLOAD_FILE_TITLE: "Ladda upp fil",
	EDIT_FILE_TITLE: "Edit file",
	UPLOAD_LINK_TITLE: "Ladda upp länk",
	UPLOAD_LINK_EDIT_TITLE: "Edit link",
	VIEW_IN_CONSULTANT_APP: "View in consultant app",
	DELETE: "Delete",
	DOCUMENT_TYPE_DOCUMENT: "DOCUMENT",
	DOCUMENT_TYPE_LINK: "LINK",
	DOCUMENT_DELETED_SUCCESS: "Document deleted successfully",
	DOCUMENT_DELETE_FAILED: "Failed to delete document",
	FILE_OR_LINK: "File / Link",
	TYPE: "Type",
	ACTIONS: "Actions",
	jobReportFeedback: {
		deleteMessageTitle: "Delete feedback",
		deleteMessageText: "Are you sure you want to delete this feedback?",
		deleted: "deleted",
	},
	otp2FA: {
		formSectionTitle: "Two-factor authentication",
		formEnableLabel: "Enable two-factor authentication via SMS for the user",
		formOrganisationRequiresHint:
			"The organisation requires two-factor authentication via SMS for all users (Settings → Organisation → Security). Login therefore always requires an SMS code regardless of the choice above, and the user must have a mobile number.",
		otpEmptyErrorMessage: "Du måste ange en kod för att fortsätta.",
		otpErrorMessage: "Felaktig kod. Försök igen.",
		enable2FA: "Aktivera tvåfaktorsinloggning med SMS",
		enable2FAMessage:
			"Vi skickar en engångskod till det angivna telefonnumret. Ange koden i nästa steg för att aktivera tvåfaktorsinloggning.",
		sendCode: "Skicka kod",
		cancel: "Avbryt",
		enterCode: "Ange din kod",
		confirm: "Bekräfta",
		resendCodeMessage: "Skicka om engångskoden om",
		second: "sekunder",
		resendCodeRemaining: "Fick du inte någon kod?",
		sendNewCode: "Klicka här för att skicka en ny",
		enabled2FA: "Tvåfaktorsinloggning är aktiverad!",
		enabled2FAMessage:
			"Nästa gång du loggar in behöver du ange en engångskod som skickas till ditt mobilnummer.",
		close: "Stäng",
		loginScreenMessage:
			"Tvåfaktorsinloggning är aktiverad för ditt konto. En engångskod har skickats till din mobil, ange koden i SMS:et nedan för att slutföra inloggningen.",
	},
	DOCUMENTS_TITLE: "Bibliotek",
	DOCUMENT_PUBLISH_ERROR: "Dokumentet kunde ej sparas",
	DOCUMENT_FILL_IN_MESSAGE: "Vänligen fyll i alla uppgifter",
	DOCUMENT_PUBLISHED_MESSAGE: "Dokumentet publicerades",
	DOCUMENT_UPDATE_MESSAGE_ERROR: "Kunde inte uppdatera dokumentet",
	DOCUMENT_UPDATE_MESSAGE_SUCCESS: "Dokumentet uppdaterades",
	notificationTags: {
		recruitment: "Recruitment",
		onboarding: "Onboarding",
		timereports: "Time Reports",
		availability: "Availability",
		confirmations: "Confirmations",
		matching: "Matching",
		allTemplates: "All Templates",
		uncategorized: "Uncategorized",
	},
	TRANSFER_CONSULTANTS: "Transfer Consultants",
	TRANSFER_CONSULTANTS_TITLE: "Transfer Consultants to New Manager",
	TRANSFER_CONSULTANTS_SELECT_MANAGER: "Select new consultant manager",
	TRANSFER_CONSULTANTS_COUNT: "{{count}} consultants will be transferred",
	TRANSFER_CONSULTANTS_CONFIRM: "Confirm Transfer",
	TRANSFER_CONSULTANTS_SUCCESS: "{{count}} consultants transferred",
	TRANSFER_CONSULTANTS_PARTIAL:
		"{{success}} of {{total}} consultants transferred. {{failed}} failed.",
	TRANSFER_CONSULTANTS_CANCEL: "Cancel",
	TRANSFER_CONSULTANTS_NO_MANAGERS: "No other consultant managers available in this organisation",

	shiftPlanner: {
		firstShift: "First shift",
		today: "Today",
		lastShift: "Last shift",
		daysUnit: "days",
		hoursUnit: "hours",
		timeReports: "Time reports",
		timeReportsHint: "All time reports for this job",
		noTimeReports: "No time reports yet",
		openTimeReports: "Open in Time reports (new tab)",
		clearAll: "Clear all shifts",
		week: "Week {{week}}, {{month}}",
		weekShort: "w.{{week}} {{month}}",
		selectConsultant: "Select consultant",
		unmanned: "Unstaffed",
		addDemand: "Add demand",
		assignOrInvite: "Book or invite consultant",
		searchConsultant: "Search consultant…",
		noMatchingConsultants: "No matching consultants",
		searchConsultants: "Search name, employee no. or personal no.",
		overlapTargets: "Selected shifts overlap each other",
		invite: "Invite",
		availability: {
			full: "Available per schedule",
			partial: "Partially available per schedule",
			none: "Not available per schedule",
			unknown: "Availability unknown",
		},
		demandDayCount: "{{count}} days",
		demandCount: "Number of consultants",
		expandGroup: "Show shifts individually",
		collapseGroup: "Group identical shifts",
		matchConsultant: "Match consultant",
		pickThisWeek: "Only this week ({{count}} shifts)",
		pickAllWeeks: "All weeks ({{count}} shifts)",
		menuBook: "Book consultant",
		menuInvite: "Invite consultant",
		changeTimes: "Change times",
		duplicate: "Duplicate",
		repeat: "Repeat",
		repeatWeekdays: "Weekdays same week",
		repeatWholeWeek: "Every day same week",
		repeatNextWeek: "Same day next week",
		repeatFourWeeks: "Same day 4 weeks ahead",
		demandAdd: "Add",
		changeConsultant: "Change consultant",
		unassignConsultant: "Remove consultant (keep shifts)",
		selectedShifts: "{{count}} selected shifts",
		change: "Change",
		fromTo: "From - To",
		breakHours: "Break (hours)",
		breakHint: "If not set, the break will be calculated according to the rule set.",
		breakShort: "{{hours}} h break",
		close: "Close (Esc)",
		done: "Done",
		showMore: "Show more ({{count}})",
		removeLane: "Remove row",
		showRows: "Show rows",
		hideRows: "Hide rows",
		overlapAlert:
			"{{name}} already has an overlapping shift ({{date}}, {{times}}). Change the times or pick another consultant.",
		removeShift: "Remove shift",
		absence: "Absence",
		applied: "Applied",
		invited: "Invited",
		pendingDetails: "Applications & invitations",
		acceptApplication: "Book",
		removeInvitation: "Remove invitation",
		help: "Help",
		reportedTimeEdited:
			"One or more shifts with reported time are being changed. Review the changes — the consultant's salary may be affected.",
		redo: "Redo",
		unsavedSummary: "{{created}} new · {{updated}} changed · {{removed}} removed",
	},

	eventTimeline: {
		noEvents: "No events recorded yet.",
		system: "System",
		via: "via {{channel}}",
		channelLabel: {
			"ai-assistant": "the AI assistant",
		},
		changed: "was changed",
		updated: "was updated",
		deletedSuffix: "(deleted)",
		loadError: "Could not fetch events",
		showMore: "Show more events",
		showMoreBody: "Show more",
		showLessBody: "Show less",
		yes: "Yes",
		no: "No",
		channel: {
			push: "push",
			mail: "email",
			sms: "SMS",
		},
		event: {
			UNKNOWN: "Event",
		},
		consultant: {
			event: {
				CONSULTANT_CREATED: "Consultant was created",
				CONSULTANT_UPDATED: "Consultant was updated",
				CONSULTANT_ACTIVATED: "Consultant was activated",
				CONSULTANT_DEACTIVATED: "Consultant was deactivated",
				CONSULTANT_BLOCKED: "Blocked for customer {{name}}",
				CONSULTANT_UNBLOCKED: "Unblocked for customer {{name}}",
				SALARY_CHANGED: "Salary was changed",
				TAG_ADDED: "Tag added: {{name}}",
				TAG_REMOVED: "Tag removed: {{name}}",
				TAG_EXPIRED: "Tag expired: {{name}}",
				TAG_RENEWED: "Tag renewed: {{name}} – valid until {{to}}",
				CERTIFICATION_ADDED: "Certification added: {{name}}",
				CERTIFICATION_REMOVED: "Certification removed: {{name}}",
				CERTIFICATION_EXPIRY_CHANGED:
					"Certification {{name}} now valid until {{to}} (was {{from}})",
				COMPETENCE_ADDED: "Competence added: {{name}}",
				COMPETENCE_REMOVED: "Competence removed: {{name}}",
				COMPETENCE_SUPPLEMENT_CHANGED: "Supplement changed for {{name}}: {{from}} → {{to}}",
				DOCUMENT_ADDED: "Document added: {{name}}",
				DOCUMENT_UPDATED: "Document updated: {{name}}",
				DOCUMENT_REMOVED: "Document removed: {{name}}",
				MANAGER_TRANSFERRED: "Consultant manager changed: {{from}} → {{to}}",
				RECRUITED: "Was employed as a consultant",
				EMPLOYMENT_STARTED_SET: "Employment start date set at first booking",
				EMPLOYMENT_CERTIFICATE_SENT: "Employment certificate was sent",
				PASSWORD_SET: "Password was set by an administrator",
				// "Sent", never "delivered" — all we observe is the handoff to the
				// push/mail/SMS provider.
				NOTIFICATION_SENT: "Message sent – {{name}}{{channels}}",
			},
			fields: {
				firstName: "First name",
				lastName: "Last name",
				email: "Email",
				profile_phoneNumber: "Phone number",
				profile_title: "Title",
				profile_pool: "Pool",
				profile_subsidiaryId: "Subsidiary",
				profile_ou1: "Organisation unit 1",
				profile_ou2: "Organisation unit 2",
				profile_socialSecurityNumber: "Personal identity number",
				profile_internalNotes: "Internal notes",
				profile_confidentialInfo: "Confidential information",
				profile_icePhone: "Next of kin, phone",
				profile_iceName: "Next of kin, name",
				profile_address_address1: "Address",
				profile_address_address2: "Address 2",
				profile_address_postalCode: "Postal code",
				profile_address_city: "City",
				profile_bank_name: "Bank",
				profile_bank_accountNumber: "Account number",
				profile_bank_clearingNumber: "Clearing number",
				profile_employment_started: "Employed from",
				profile_employment_ended: "Employed until",
				profile_employment_title: "Employment title",
				profile_employment_union: "Union",
				profile_employment_employmentOption: "Type of employment",
				profile_employment_colAgreement_id: "Collective agreement",
			},
		},
		customer: {
			event: {
				CUSTOMER_CREATED: "Customer was created",
				CUSTOMER_UPDATED: "Customer was updated",
				CUSTOMER_ACTIVATED: "Customer was activated",
				CUSTOMER_DEACTIVATED: "Customer was deactivated",
				CUSTOMER_DELETED: "Customer was deleted",
				CONTRACT_CHANGED: "Contract changed: {{from}} → {{to}}",
				SUBSIDIARY_CHANGED: "Subsidiary changed: {{from}} → {{to}}",
				TAG_ADDED: "Tag added: {{name}}",
				TAG_REMOVED: "Tag removed: {{name}}",
				USER_ADDED: "User added: {{name}}",
				USER_REMOVED: "User removed: {{name}}",
				DELIVERY_STATE_SET_BY_FORTNOX: "{{deliveryLabel}}",
			},
			fields: {
				name: "Name",
				customerNumber: "Customer number",
				vatNumber: "VAT number",
				phoneNumber: "Phone number",
				description: "Description",
				directions: "Directions",
				internalNotes: "Internal notes",
				ou1: "Organisation unit 1",
				ou2: "Organisation unit 2",
				pool: "Pool",
				resultUnit: "Result unit",
				privatePerson: "Private person",
				breakTime: "Break",
				corporateGroup_id: "Corporate group",
				visitingAddress_address1: "Visiting address",
				visitingAddress_address2: "Visiting address 2",
				visitingAddress_postalCode: "Postal code",
				visitingAddress_city: "City",
				visitingAddress_country: "Country",
				invoiceDetails_invoiceName: "Invoice name",
				invoiceDetails_GLNCode: "GLN code",
				invoiceDetails_address1: "Invoice address",
				invoiceDetails_address2: "Invoice address 2",
				invoiceDetails_postalCode: "Postal code (invoice)",
				invoiceDetails_city: "City (invoice)",
				invoiceDetails_country: "Country (invoice)",
				invoiceDetails_reference: "Reference",
				invoiceDetails_costCenter: "Cost centre",
				invoiceDetails_email: "Email (invoice)",
				invoiceDetails_deliveryMethod: "Delivery method",
				invoiceDetails_deliveryManagedBy: "Managed by",
			},
		},
	},

	jobTimeline: {
		noEvents: "There are no events for this job yet.",
		system: "System",
		consultantFallback: "The consultant",
		loadError: "Could not fetch events",
		changed: "was changed",
		event: {
			JOB_CREATED: "Job was created",
			JOB_UPDATED: "Job was updated",
			JOB_CANCELED: "Job was cancelled",
			JOB_DELETED: "Job was deleted",
			JOB_DENIED: "Job was denied",
			JOB_REOPENED: "Job was reopened",
			JOB_STATUS_CHANGED: "Status changed: {{from}} → {{to}}",
			APPLICATION_CREATED: "{{consultant}} applied for the job",
			ACCEPTED_APPLICATION_CREATED: "{{consultant}} was booked on the job",
			APPLICATION_ACCEPTED: "Application from {{consultant}} was accepted",
			APPLICATION_DECLINED: "Application from {{consultant}} was declined",
			APPLICATION_DELETED: "Application from {{consultant}} was removed",
			APPLICATION_CANCELLED: "{{consultant}} cancelled their application",
			APPLICATIONS_CANCELLED_OVERLAP:
				"Application from {{consultant}} was cancelled since the consultant was booked on another job",
			INVITATION_CREATED: "{{consultant}} was invited to the job",
			INVITATION_UPDATED: "Invitation to {{consultant}} was updated",
			INVITATION_DECLINED: "{{consultant}} declined the invitation",
			INVITATION_DELETED: "Invitation was removed",
			INVITATION_ACCEPTED: "{{consultant}} accepted the invitation",
			INVITATIONS_DELETED_OVERLAP:
				"Invitation to {{consultant}} was removed since the consultant was booked on another job",
			INVITATION_EXPIRED: "Invitation to {{consultant}} expired",
			SHIFT_ADDED: "Shift was added",
			SHIFT_UPDATED: "Shift was updated",
			SHIFT_REMOVED: "Shift was removed",
			TIME_REPORT_REPORTED: "Time report was submitted",
			TIME_REPORT_ATTESTED_BY_ADMIN: "Time report was attested internally",
			TIME_REPORT_ATTESTED_BY_CUSTOMER: "Time report was attested by the customer",
			TIME_REPORT_SILENT_ATTESTED: "Time report was attested automatically",
			TIME_REPORT_INVOICED: "Time report was invoiced",
			TIME_REPORT_UNDO: "Time report was reverted",
			UNKNOWN: "Event",
		},
		status: {
			OPEN: "Open",
			BOOKED: "Booked",
			BOOKED_WITH_UNMANNED_SHIFTS: "Booked with unmanned shifts",
			DECLINED: "Denied",
			CANCELLED: "Cancelled",
			DELETED: "Deleted",
		},
		fields: {
			description: "Description",
			customerDescription: "Description to customer",
			internalNotes: "Internal notes",
			contactPersons: "Contact persons",
			competence: "Competence",
			pool: "Pool",
			tags: "Tags",
			requirements: "Requirements",
			hidden: "Hidden",
			flag: "Flag",
			address: "Address",
			numPositions: "Number of positions",
			bookingType: "Booking type",
			price: "Price",
			noOfHours: "Number of hours",
			noOfDays: "Number of days",
			startDate: "Start date",
			endDate: "End date",
			status: "Status",
			start: "Start time",
			end: "End time",
			break: "Break",
			flexible: "Flexible start time",
			documents: "Documents",
			videos: "Videos",
			customerOrderNumber: "Customer order number",
			purchaseOrderNo: "Purchase order number",
			invoiceReference: "Invoice reference",
			source: "Source",
			taxDeduction: "RUT/ROT",
			isLongTerm: "Long term",
			contract: "Contract",
			allowLaterBooking: "Allow later booking",
		},
	},
	consultantPanel: {
		matchTab: "Match",
		candidatesTab: "Candidates",
		selectConsultantsFor: "Select consultant for {{count}} shifts",
		selectedShifts: "{{count}} selected shifts",
		wholeJob: "Whole job",
		requirements: "Requirements",
		jobRequirements: "Job matching",
		jobRequirementsHint: "The filter equals the job's competence and matching requirements",
		resetRequirements: "Reset to job matching",
		addCertification: "Certification",
		addTag: "Tag",
		allCompetences: "All competences",
		changeCompetence: "Change competence",
		jobCompetenceMarker: "Job competence",
		removeSkillHint: "Remove to widen the match",
		notMatching: "Does not meet the requirements ({{count}})",
		missing: "Missing",
		selectShiftsFirst: "Select shifts in the schedule first",
		noCandidates: "No consultants are booked, invited or have applied yet.",
		replaceBookedTitle: "Unbook booked consultant?",
		replaceBookedDescription:
			"A consultant is already booked and will be unbooked when you invite consultant(s) to the same shifts. Do you want to continue?",
		uninvite: "Remove invitation",
		shiftsUnit: "shifts",
	},
	jobCandidates: {
		inboxTitle: "Applications & invitations",
		pendingCount: "{{count}} waiting",
		pendingCount_plural: "{{count}} waiting",
		searchTitle: "Find consultants",
		appliedAt: "Applied {{date}}",
		invitedAt: "Invited {{date}}",
		invitedFor: "Invited for",
		showInSchedule: "Show in schedule",
		willBook: "Books",
		bookNShifts: "Book {{count}} shifts",
		bookShiftsTitle: "Book {{name}}",
		chooseShifts: "Choose which shifts to book",
		bookShiftsHint: "Choose which shifts to book — only available shifts are listed.",
		overlapsSelected: "Overlaps a selected shift",
		fullyStaffed: "All shifts are staffed",
		showAllShifts: "Show all {{count}}",
		showFewerShifts: "Show fewer",
		deleteApplication: "Delete",
		deleteApplicationHint: "Remove the application entirely so the consultant can apply again",
		deleteApplicationTitle: "Delete application?",
		deleteApplicationConfirm:
			"The application is removed entirely and the consultant can apply for the job again. This cannot be undone.",
		applicationDeleted: "Application removed",
		earlier: "Earlier ({{count}})",
		earlier_plural: "Earlier ({{count}})",
		assignTag: "Assign/renew tag...",
		removeTag: "Remove tag...",
		guaranteedHours: "Guaranteed hours",
	},

	customFields: {
		inheritedFromCustomer: "Inherited from customer",
		inheritedFromCustomerValue: "Inherited from customer: {{value}}",
		noCustomerValue: "No value on the customer",
		resetToInherited: "Reset to inherited",
		inheritFromCustomer: "Inherit from customer",
		noValue: "None",
		selectPlaceholder: "Select…",
		ownedByCorporateGroup: "Owned by corporate group",
		noCorporateGroupValue: "Owned by corporate group · no value on the corporate group",
		setByCorporateGroup: "Set by the corporate group",
	},
};

export default en;
